"use client";

import { Typography } from "@/components/ui/typography";
import type { IndustriesProcessProps } from "./types";
import { industriesProcessData } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { ProcessCards } from "@/components/screen/global-components/process";
import { Button } from "@/components/ui/button";
import Link from "next/link";

const IndustriesProcess = ({ className }: IndustriesProcessProps) => {
  const { title, description, actionText, cards } = industriesProcessData;

  return (
    <section className={cn("section lg:bg-background-secondary", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4">
          <Typography variant="heading4" className="md:text-center">
            <h2>{title}</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 max-w-[780px] mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <ProcessCards cards={cards} className="mt-6 md:mt-12" />
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href="/quality-guarantee" className="!text-base">
              {actionText}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default memo(IndustriesProcess);
